import React from 'react';
import '../CSS/Header.css';

export default function Header() {
    return (
        <header className="mc-header-v2">
            <div className="mc-top-bar">
                <div className="mc-header-container">
                    {/* Ліва частина: Телефон */}
                    <div className="mc-top-left">
                        <a href="tel:+380972934602" className="mc-top-phone">
                            +38 097 293 46 02
                            <img src={require('../IMG/tel1.svg').default} alt="Instagram" />
                        </a>
                    </div>

                    {/* Права частина: Соцмережі */}
                    <div className="mc-top-right">
                        <div className="mc-socials">
                            <a href="https://www.instagram.com/mentalclinic.ua/" target="_blank" rel="noreferrer" className="soc-img-link">
                                <img src={require('../IMG/insta.svg').default} alt="Instagram" />
                            </a>
                            <a href="https://t.me/MentalClinicUA" target="_blank" rel="noreferrer" className="soc-img-link">
                                <img src={require('../IMG/telegram.svg').default} alt="Telegram" />
                            </a>
                            <a href="tel:+380972934602" className="soc-img-link">
                                <img src={require('../IMG/tel2.svg').default} alt="Phone" />
                            </a>
                             <a href="viber://chat?number=%2B380972934602" className="soc-img-link">
                                <img src={require('../IMG/viber.svg').default} alt="Viber" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* MAIN BAR */}
            <div className="mc-main-bar">
                <div className="mc-header-container">

                    {/* LOGO */}
                    <div className="mc-logo-wrapper">
                        <a href="https://mentalclinic.com.ua/">
                            <img src={require('../IMG/logo.svg').default} alt="Mental Clinic" />
                        </a>
                    </div>

                    {/* NAV BAR */}
                    <nav className="mc-main-nav">
                        <ul>
                            <li>
                                <a href="https://mentalclinic.com.ua/services" className="has-dropdown">
                                    Послуги
                                </a>
                            </li>
                            <li>
                                <a href="https://mentalclinic.com.ua/tests/">Тести</a>
                            </li>
                            <li>
                                <a href="https://mentalclinic.com.ua/pricing/">Вартість</a>
                            </li>
                            <li>
                                <a href="https://mentalclinic.com.ua/shop">Абонементи</a>
                            </li>
                            <li>
                                <a href="https://mentalclinic.com.ua/doctors/">Команда</a>
                            </li>
                        </ul>
                    </nav>

                    {/* КНОПКА ЗАПИСУ */}
                    <div className="mc-main-actions">
                        <a href="https://booking.mentalclinic.com.ua/" className="mc-btn-online">Онлайн-запис</a>
                    </div>
                </div>
            </div>
        </header>
    );
}